import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.2 12.71" {...props}>
    <path
      d="m21838.501 1560.678 8.499-8.298 2.1 2.12-10.6 10.61zm-10.601-6.178 2.1-2.12 8.501 8.298v4.432z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-21827.9 -1552.38)"
    />
  </svg>
);
export default SvgArrowDown;
